import { compose, withProps, setPropTypes, defaultProps } from 'recompose';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { headerContentAlignmentPropTypes } from '../../../../config/sectionHeader/sectionHeaderPropTypes';

import styles from './withHeaderContentAlignmentStyles.scss';

export default compose(
  setPropTypes({
    className: PropTypes.string,
    logoImageAlign: headerContentAlignmentPropTypes,
  }),
  defaultProps({
    logoImageAlign: '',
  }),
  withProps(({ className, logoImageAlign }) => ({
    className: cx(className, styles[logoImageAlign]),
  })),
);
